<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogDepartmentVisible" width="520px" :before-close="handleDepartmentClose" :close-on-click-modal="false"
        class="custom-form-dialog">
        <el-form ref="departmentForm" :rules="departmentFormRules" :model="departmentForm" label-position="top">
            <el-form-item label="变更部门" prop="did">
                <el-select  placeholder="请选择部门" ref="department_select" v-model="departmentForm.didTitle" :remote-method="getDepartmentList"
                    filterable remote reserve-keyword>
                    <el-option :value="departmentForm.didTitle" style="height: auto;padding: 0">
                        <el-tree :data="depOptions" :expand-on-click-node='false' :props="{ children: 'children', label: 'department_name' }" @node-click="handleClickDepNode"
                            check-on-click-node check-strictly default-expand-all node-key="id" ref="depTree">
                        </el-tree>
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDepartmentClose">取消</el-button>
            <el-button type="primary" :disabled="btnDisabled" @click.stop="handleDepartmentConfirm">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {GetCompanyDepartmentList,UpdateUserDepartment} from "@/api";
export default {
    name: "changeDepartment",
    props: {
        dialogDepartmentVisible: {
            type: Boolean,
            default: false
        },
        change_department_user_id: {
            type: Array,
            default: ()=>[]
        },
    },
    data() {
        return {
            btnDisabled:false,
            dialogTitle: "变更部门",
            departmentForm: {
                did: "",
                didTitle: ""
            },
            departmentFormRules: {
                did: [
                    { required: true, message: "请选择要变更的部门", trigger: "change" }
                ]
            },
            depOptions: []
        }
    },
    created() {
        this.getDepartmentList()
    },
    methods: {
        // 部门搜索
        getDepartmentList(title) {
            GetCompanyDepartmentList().then(res => {
                if (res.code === 200) {
                    this.depOptions = res.data.departments || []
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleDepartmentClose() {
            this.$emit("update:dialogDepartmentVisible", false)
        },
        handleClickDepNode(data, node, nodeData) {
            this.departmentForm.didTitle = data.department_name;
            this.departmentForm.did = data.id
            this.$refs.department_select.handleClose()
        },
        handleDepartmentConfirm() {
            this.$refs.departmentForm.validate(valid => {
                if (valid) {
                    let postData = {
                        department_id:this.departmentForm.did,
                        user_ids:this.change_department_user_id
                    }
                    this.btnDisabled = true
                    UpdateUserDepartment(postData).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: res.message,
                                duration: 1500,
                                onClose: () => {
                                    this.btnDisabled = false
                                    this.$emit('success')
                                    this.handleDepartmentClose()
                                }
                            })
                        } else {
                            this.btnDisabled = false
                            this.$message.error(res.message)
                        }
                    })
                }
            })
        }
    }
}
</script>
